import ReactEChartsCore from "echarts-for-react/lib/core";
import { LineChart } from "echarts/charts";
import { GridComponent, LegendComponent, TitleComponent, TooltipComponent } from "echarts/components";
import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import styles from "../styles/analyticsCharts.module.css";

const AnalyticsHorizontalPinChart = ({ title, labels, primaryData, secondaryData }: AnalyticsChartProps) => {
  //these are in the app.css, but I'm not sure how to apply css to these charts
  const blueLight = "#90D6E6";
  const blueMedium = "#0090BC";
  const blueDark = "#0D4D87";
  const gold = "#FCB415";
  const orangeLight = "#F6861F";
  const orangeMedium = "#F15523";
  const redLight = "#EE2B31";
  const redMedium = "#C02026";
  const redDark = "#8C1821";
  const lightGrey = "#e8e8e8";

  const maxPrimary = primaryData ? Math.max(...primaryData) : 0;
  const maxSecondary = secondaryData ? Math.max(...secondaryData) : 0;
  const maxY = maxPrimary > maxSecondary ? maxPrimary : maxSecondary;
  echarts.use([TitleComponent, TooltipComponent, GridComponent, LineChart, LegendComponent, CanvasRenderer]);

  const tooltipFormatter = (params: any) => {
    return params
      .map(
        ({ value, seriesName, borderColor }: any) =>
          `<div class="dot me-1 fs-11 d-inline-block" style="background-color: ${borderColor}"></div>
              <span class='text-600'>${seriesName}: ${value}</span>`,
      )
      .join("<br/>");
  };

  const getOptions = () => ({
    color: lightGrey,
    tooltip: {
      trigger: "axis",
      padding: [7, 10],
      backgroundColor: lightGrey,
      borderColor: blueLight,
      textStyle: {
        color: blueDark,
        fontWeight: 500,
        fontSize: 11,
        fontFamily: "Inter",
      },
      borderWidth: 1,
      formatter: tooltipFormatter,
      transitionDuration: 0,
    },
    legend: {
      data: ["Followers", "Check-Ins"],
      show: false,
    },
    xAxis: [
      {
        type: "category",
        position: "bottom",
        data: labels,
        boundaryGap: false,
        axisPointer: {
          lineStyle: {
            color: gold,
            type: "line",
          },
        },
        splitLine: { show: false },
        axisLine: {
          lineStyle: {
            color: lightGrey,
            type: "line",
          },
        },

        axisTick: { show: true },
        axisLabel: {
          color: blueDark,
          margin: 15,
          // showMinLabel: true,
          // showMaxLabel: true,
          align: "center",
        },
      },
    ],
    yAxis: {
      type: "value",
      splitNumber: maxY / 3,
      axisPointer: { show: false },
      splitLine: {
        lineStyle: {
          color: lightGrey,
          type: "line",
        },
      },
      boundaryGap: false,
      axisLabel: {
        showMinLabel: false,
        show: true,
        color: blueDark,
        formatter: maxY,
      },
      axisTick: { show: false },
      axisLine: { show: false },
    },
    series: [
      {
        name: "Followers",
        type: "line",
        data: primaryData,
        lineStyle: { color: blueMedium },
        itemStyle: {
          borderColor: blueMedium,
          borderWidth: 3,
        },
        symbol: "circle",
        symbolSize: 10,
        emphasis: {
          scale: true,
        },
      },
      {
        name: "Check ins",
        type: "line",
        data: secondaryData,
        lineStyle: { color: blueLight, type: "dashed" },
        itemStyle: {
          borderColor: blueLight,
          borderWidth: 3,
        },
        symbol: "circle",
        symbolSize: 10,
        emphasis: {
          scale: true,
        },
      },
    ],
    grid: {
      right: "30px",
      left: "30px",
      bottom: "15%",
      top: "5%",
    },
  });

  return (
    <div className={styles.chartWrapper}>
      <h2 className={styles.header}>{title}</h2>
      <ReactEChartsCore echarts={echarts} option={getOptions()} />
    </div>
  );
};

export default AnalyticsHorizontalPinChart;
